/**
 * Style Advisor service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxStyleAdvisorSvc', ItxStyleAdvisorSvc);

    ItxStyleAdvisorSvc.$inject = [
        'CommonServices',
        '$rootScope',
        '$q',
        'CmsConfigSvc',
        'ItxScreenSizeSvc',
        'ItxConfigurationSvc',
        'ItxChatSvc'
    ];

    function ItxStyleAdvisorSvc(
        CommonServices,
        $rootScope,
        $q,
        CmsConfigSvc,
        ItxScreenSizeSvc,
        ItxConfigurationSvc,
        ItxChatSvc
    ) {
        var _this = this;

        /**
         * Inicialización de la configuración
         */
        _this.styleAdvisor = {
            isEnabled: true
        };

        var service = {
            initWidget: _initWidget,
            showButton: _showButton,
            checkIfEnabled: _checkIfEnabled
        };

        return service;

        /**
         * Inicializa el widget en la página
         */
        function _initWidget(config) {
            var styleAdvisorScriptTagOne = document.createElement('script');
            var styleAdvisorScriptTagTwo = document.createElement('script');

            styleAdvisorScriptTagOne.id = 'style-advisor-code-one';
            styleAdvisorScriptTagOne.type = 'text/javascript';
            styleAdvisorScriptTagOne.text =
                'window.HeroWebPluginSettings = { applicationId: "' + _getAppId(config) + '" };';

            styleAdvisorScriptTagTwo.id = 'style-advisor-code-two';
            styleAdvisorScriptTagTwo.type = 'text/javascript';
            styleAdvisorScriptTagTwo.text =
                '(function(i,a,m,h,e,r,o){i.HeroObject=e;i[e]=i[e]||function(){(i[e].q=i[e].q||[]).push(arguments)},i[e].l=1*new Date;r=a.createElement(m),o=a.getElementsByTagName(m)[0];r.async=1;r.src=h;o.parentNode.insertBefore(r,o)})(window,document,"script","https://cdn.usehero.com/loader.js","hero");'; // jshint ignore:line

            document.body.appendChild(styleAdvisorScriptTagOne);
            document.body.appendChild(styleAdvisorScriptTagTwo);

            hero('onReady', function (event) {
                // Abrimos directamente la ventana de Style Advisor en Apps
                if (!CommonServices.isWebapp()) {
                    // Si Style Advisor esta en uso y no es mobile, abrimos la ventana
                    if (
                        inditex.getLocalStorage('openStyleAdvisorInUse') &&
                        ItxScreenSizeSvc.is('md,lg')
                    ) {
                        $('#hero-iframe-container').addClass('open');
                        $('#hero-iframe-container div.hero-launcher-container.active').addClass(
                            'show'
                        );

                        hero('show');

                        $rootScope.$broadcast('changeChatVisualizations', {
                            event: 'hideButton'
                        });
                    } else {
                        hero('hide');
                    }
                }
            });

            // Al mostrar Style Advisor
            hero('onShow', function () {
                // Quitamos del storage el control de intento de apertura
                inditex.removeLocalStorage('openStyleAdvisorAttempt');
            });

            // Al cerrar Style Advisor
            hero('onHide', function () {
                // Mostramos el botón de selección de chats y ocultamos el de Hero
                $('#hero-iframe-container div.hero-launcher-container.active').removeClass('show');

                $rootScope.$broadcast('changeChatVisualizations', {
                    event: 'showButton'
                });

                // Quitamos del storage el control de uso
                inditex.removeLocalStorage('openStyleAdvisorInUse');
            });
        }

        /**
         * Función para mostrar el botón de Style Advisor
         */
        function _showButton() {
            $('#hero-iframe-container div.hero-launcher-container.active').addClass('show');
        }

        /**
         * Función para comprobar si Style Advisor está activo
         */
        function _checkIfEnabled() {
            var deferred = $q.defer();

            // Obtenemos la configuración
            CmsConfigSvc.getProperty('chatbot_style_advisor').then(function (styleAdvisorConfig) {
                // Comprobamos si debe estar activo
                var secondDeferred = $q.defer();

                ItxChatSvc.checkIfStyleAdvisorIsActive(styleAdvisorConfig).then(function (
                    styleAdvisorConfig
                ) {
                    if (styleAdvisorConfig.active) {
                        secondDeferred.resolve(true);
                    } else {
                        secondDeferred.resolve(false);
                    }
                });

                deferred.resolve(secondDeferred.promise);
            });

            return deferred.promise;
        }

        /**
         * Función para obtener el appId en base al entorno
         */
        function _getAppId(config) {
            var appId;

            switch (ItxConfigurationSvc.getEnvironment()) {
                case 'DEVELOPMENT':
                    appId = config.devAppId;
                    break;
                case 'PREPRU':
                    appId = config.devAppId;
                    break;
                case 'PRUSTG':
                    appId = config.devAppId;
                    break;
                case 'STAGE':
                    appId = config.devAppId;
                    break;
                case 'PRO':
                    appId = config.appId;
                    break;
            }

            return appId;
        }
    }
})();
